export const aboutInfo = {
  story: {
    title: '关于蘑菇网',
    subtitle: '让每一位女性都能轻松找到属于自己的时尚风格',
    content: `蘑菇网创立于2018年，源自创始人对时尚的热爱和对品质的执着追求。我们相信，时尚不应该只是少数人的特权——每一位女性都应该有机会以合理的价格，享受到高品质的时尚单品与专业的穿搭建议。

品牌名称"蘑菇"寓意着自然、生长和活力。我们希望像蘑菇在雨后悄然生长一样，陪伴每一位女性在时尚的道路上不断发现自我、绽放光彩。

从最初的小型线上买手店，到如今汇聚海量潮流单品的时尚购物平台，蘑菇网始终秉持一个使命：为追求美好生活的女性，提供高品质、高性价比的时尚选择。

我们拥有超过500个国内外优质品牌合作伙伴，从新锐设计师品牌到国际知名品牌，从日常基础款到场合着装单品，品类涵盖女装、配饰、鞋履与美妆。每一件上架的商品，都经过了严格的品质把关与风格审核。`,
    image: 'https://readdy.ai/api/search-image?query=Elegant%20modern%20fashion%20office%20interior%20with%20warm%20neutral%20tones%2C%20natural%20light%20streaming%20through%20large%20windows%2C%20clothing%20racks%20with%20beautiful%20garments%2C%20minimalist%20aesthetic%2C%20creative%20workspace%2C%20plants%20and%20natural%20elements%2C%20editorial%20photography&width=1200&height=800&seq=about-story&orientation=landscape',
  },
  milestones: [
    { year: '2018', event: '蘑菇网正式上线，以买手精选模式切入女装市场' },
    { year: '2019', event: '合作品牌突破100家，月活跃用户突破10万' },
    { year: '2020', event: '上线穿搭推荐功能，为用户提供个性化搭配建议' },
    { year: '2021', event: '推出自有品牌MOGU Studio，聚焦高品质基础款' },
    { year: '2022', event: '完成A轮融资，团队扩展至200人' },
    { year: '2023', event: '年交易额突破5亿元，用户覆盖全国300+城市' },
    { year: '2024', event: '上线美妆配饰品类，打造一站式时尚购物体验' },
    { year: '2025', event: '累计服务用户超过500万，成为时尚女装头部平台' },
    { year: '2026', event: '持续创新产品与服务，为用户带来更好的购物体验' },
  ],
  values: [
    { title: '品质至上', description: '每一件商品都经过三道质检流程，确保面料、做工、版型达到标准', icon: 'ri-shield-check-line' },
    { title: '风格多元', description: '从极简到浪漫，从通勤到度假，不同风格的女性都能在这里找到心仪单品', icon: 'ri-palette-line' },
    { title: '价格合理', description: '直接与品牌和工厂合作，减少中间环节，让高品质时尚触手可及', icon: 'ri-price-tag-3-line' },
    { title: '服务贴心', description: '7天无忧退换、专业客服团队、个性化穿搭建议，让购物体验更安心', icon: 'ri-heart-line' },
  ],
  testimonials: [
    {
      name: '林小姐',
      role: '资深用户 · 3年',
      content: '蘑菇网是我买衣服的首选平台，品质好、款式新、价格还实惠。最让我喜欢的是穿搭推荐功能，帮我省了不少搭配的烦恼。',
      avatar: 'https://readdy.ai/api/search-image?query=Elegant%20professional%20asian%20woman%20portrait%20in%20warm%20neutral%20tones%2C%20soft%20natural%20lighting%2C%20clean%20cream%20background%2C%20minimalist%20style%2C%20editorial%20quality&width=200&height=200&seq=avatar-lin&orientation=squarish',
    },
    {
      name: '王女士',
      role: 'VIP会员 · 2年',
      content: '自从开始用蘑菇网，我的衣橱发生了翻天覆地的变化。以前总觉得没衣服穿，现在随便搭配都好看。质量也真的很能打，洗了好多次都不变形。',
      avatar: 'https://readdy.ai/api/search-image?query=Elegant%20stylish%20asian%20woman%20portrait%20in%20warm%20neutral%20tones%2C%20soft%20natural%20lighting%2C%20clean%20cream%20background%2C%20minimalist%20style%2C%20editorial%20quality&width=200&height=200&seq=avatar-wang&orientation=squarish',
    },
    {
      name: '张同学',
      role: '学生用户 · 1年',
      content: '作为学生党预算有限，蘑菇网的折扣区和学生优惠真的很友好！而且风格多样，从日常上课到面试正装都能一站搞定。',
      avatar: 'https://readdy.ai/api/search-image?query=Elegant%20young%20asian%20woman%20portrait%20in%20warm%20neutral%20tones%2C%20soft%20natural%20lighting%2C%20clean%20cream%20background%2C%20minimalist%20style%2C%20editorial%20quality&width=200&height=200&seq=avatar-zhang&orientation=squarish',
    },
  ],
  contact: {
    email: 'hello@moguwang.com',
    phone: '400-888-6688',
    address: '上海市静安区南京西路1688号蘑菇大厦18层',
    wechat: '蘑菇网官方',
    weibo: '@蘑菇网时尚女装',
    workingHours: '周一至周日 9:00 - 21:00',
  },
  faqs: [
    {
      question: '蘑菇网的商品是正品吗？',
      answer: '蘑菇网所有商品均来自品牌官方授权渠道或直接品牌合作，100%正品保证。我们建立了严格的供应链审核机制，每一件商品都有完整的溯源信息，让您购物无忧。',
    },
    {
      question: '退换货政策是怎样的？',
      answer: '蘑菇网支持7天无理由退换货。只要商品未经穿着使用、保持原包装完整，您可以在签收后7天内申请退换。我们提供上门取件服务，整个流程方便快捷。',
    },
    {
      question: '如何获取穿搭推荐？',
      answer: '您可以在蘑菇网App或官网浏览「穿搭灵感」板块，我们的时尚编辑团队每日更新穿搭搭配。也可以输入您的身材信息、风格偏好，系统会为您生成个性化穿搭方案。',
    },
    {
      question: '会员有什么权益？',
      answer: '蘑菇网会员体系分为银卡、金卡和钻石卡三个等级。会员可享受专属折扣、生日礼券、优先发货、专属客服等多项权益。累计消费越多，等级越高，权益越丰富。',
    },
    {
      question: '如何联系客服？',
      answer: '您可以通过以下方式联系我们的客服团队：在线客服（官网右下角聊天窗口）、客服电话 400-888-6688（每日9:00-21:00）、微信公众号留言。我们的客服团队将在第一时间为您服务。',
    },
  ],
};